<template>
    <v-container>
        <v-card>
            <v-card-title>
                <h5 class="headline mb-0">Остаток касса всего {{  Number(Number(this.eskhata)+Number(this.ost_kassa)+Number(this.dc)+Number(this.alif)).toFixed(2) }} </h5>
                <v-divider class="mx-3" inset vertical></v-divider>
                 <!-- <h6>Наличные деньги: {{ ost_kassa }}</h6>
                <v-divider class="mx-3" inset vertical></v-divider>
                <h6>Душанбе сити: {{ dc }}</h6>
                <v-divider class="mx-3" inset vertical></v-divider>
                <h6>Эсхата: {{ eskhata }}</h6>
                <v-divider class="mx-3" inset vertical></v-divider>
                <h6>Алиф: {{ alif }}</h6>
                <v-divider class="mx-3" inset vertical></v-divider> -->
            </v-card-title>
            <apexchart type="pie" ref="ost_kassa" width="700" :options="chartOptions" :series="series"></apexchart>
        </v-card>
    </v-container>

</template>

<script>
export default {

    data() {
        return {


            series: [],



          chartOptions: {
            chart: {
              width: 500,
              type: 'pie',
            },

            legend: {

              formatter: function(val, opts) {
                return val + "  " + opts.w.globals.series[opts.seriesIndex]
              }
            },







            labels: ["Эсхата", "Наличные деньги", "Душанбе сити", " Алиф"],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom',

                },



              }
            }]
          },


          loading: false,
          kkk:[],
          alif:0,
          dc:0,
            eskhata:0,
            ost_kassa:0,

        }
    },

    mounted() {
        this.get_kassa();
    },

    methods:{
        get_kassa() {
            this.loading = true;
            axios.get('/api/get_ost_kassa',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;

                                  var array = [response.data.alif, response.data.eskhata, response.data.dc, response.data.ost_kassa];
                                 // this.series = array;
                                 this.alif= response.data.alif;
                                    this.eskhata= response.data.eskhata;
                                    this.dc= response.data.dc;
                                    this.ost_kassa= response.data.ost_kassa;


                                  this.$refs.ost_kassa.updateSeries(
                                     [
                                        Number(this.eskhata),Number(this.ost_kassa),Number(this.dc),Number(this.alif)
                                     ]

                                  )


                                 // console.log(this.series);


                                // console.log(response.data.alif);
                                // console.log(response.data.eskhata);
                                // console.log(response.data.dc);
                                // console.log(response.data.ost_kassa);
                             // this.series = response.data.kassa;




                              }
                          })
                          .catch(error => {
                              this.loading = false;

                          });
        },
    },

}
</script>

<style>

</style>
